import { lazyPanes } from '@/lib/lazy-panes'

/** The team screen's panes, off the /teams list chunk; the `$teamId` loader preloads them. */
export const teamDetail = lazyPanes(() => import('./team-detail-panes'))
